import { Box, InputLabel, TextField } from "@mui/material";
import React from "react";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";

export default function DegreesDecimalMinutes(props) {
  return (
    <Box mt={0} width="100%" align="center">
      <h2 className="sectionTitle center">Degrees Decimal Minutes</h2>
      <Grid container justifyContent="center" alignItems="center" spacing={3}>
        <Grid item xs={12}>
          <InputLabel className="select-title">
            Latitude Degrees Decimal Minutes
          </InputLabel>
        </Grid>
        <Grid item xs={12} md="auto">
          <FormControl>
            <TextField
              variant="standard"
              inputProps={{ style: { textAlign: "center" } }}
              label="Degrees:"
              className="number-of-input"
              value={
                props.latitude_or_loran1.degrees_decimal_minutes.degrees
                  ? Number(
                      props.latitude_or_loran1.degrees_decimal_minutes.degrees
                    )
                  : ""
              }
              name="degrees"
              type="number"
              onChange={(e) => props.handleLatChange(e)}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md="auto">
          <FormControl>
            <TextField
              variant="standard"
              inputProps={{
                min: 0,
                max: 60,
                style: { textAlign: "center", width: 165 },
              }}
              label="Decimal Minutes:"
              className="number-of-input"
              value={
                props.latitude_or_loran1.degrees_decimal_minutes.minutes
                  ? Number(
                      props.latitude_or_loran1.degrees_decimal_minutes.minutes
                    )
                  : ""
              }
              name="minutes"
              type="number"
              onChange={(e) => props.handleLatChange(e)}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <InputLabel className="select-title">
            Longitude Degrees Decimal Minutes
          </InputLabel>
        </Grid>
        <Grid item xs={12} md="auto">
          <FormControl>
            <TextField
              variant="standard"
              inputProps={{ style: { textAlign: "center" } }}
              label="Degrees:"
              className="number-of-input"
              value={
                props.longitude_or_loran2.degrees_decimal_minutes.degrees
                  ? Number(
                      props.longitude_or_loran2.degrees_decimal_minutes.degrees
                    )
                  : ""
              }
              name="degrees"
              type="number"
              onChange={(e) => props.handleLonChange(e)}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md="auto">
          <FormControl>
            <TextField
              variant="standard"
              inputProps={{
                min: 0,
                max: 60,
                style: { textAlign: "center", width: 165 },
              }}
              label="Decimal Minutes:"
              className="number-of-input"
              value={
                props.longitude_or_loran2.degrees_decimal_minutes.minutes
                  ? Number(
                      props.longitude_or_loran2.degrees_decimal_minutes.minutes
                    )
                  : ""
              }
              name="minutes"
              type="number"
              onChange={(e) => props.handleLonChange(e)}
            />
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  );
}
